import React from 'react'
import classnames from 'classnames'

export default function Icon({ name, small, onClick }) {
  const classNames = classnames('icon', {
    small: small,
  })

  return (
    <div onClick={() => onClick && onClick()}>
      <img
        className={classNames}
        src={require(`../../icons/${name}.svg`)}
        alt={name}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/common/Icon.js